import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {ActionList, ActionMenu} from '@primer/react'
import {useRef} from 'react'

import {
  CustomPropertySingleSelectPanel,
  type CustomPropertySingleSelectPanelProps,
  mixedValuePlaceholder,
} from './CustomPropertySelectPanel'

interface CustomPropertyBooleanSelectProps extends CustomPropertySingleSelectPanelProps {
  propertyValue: string
}

const buttonLabels: Record<string, string> = {
  true: 'True',
  false: 'False',
}

export function CustomPropertyBooleanSelect(inputProps: CustomPropertyBooleanSelectProps) {
  const booleanToggleEnabled = useFeatureFlag('boolean_property_value_toggle')

  const {propertyDefinition, propertyValue, onChange, mixed} = inputProps
  const {defaultValue} = propertyDefinition

  const initiallyMixedRef = useRef(mixed)

  return booleanToggleEnabled && !defaultValue ? (
    <ActionMenu>
      <ActionMenu.Button sx={{width: '100%', 'span[data-component=buttonContent]': {justifyContent: 'start'}}}>
        {mixed ? mixedValuePlaceholder : buttonLabels[propertyValue] || 'Choose an option'}
      </ActionMenu.Button>
      <ActionMenu.Overlay>
        <ActionList selectionVariant="single" role="menu" aria-label="True/False property value selections">
          {initiallyMixedRef.current && (
            <>
              <ActionList.Item selected={mixed} inactiveText="This property has multiple values">
                Mixed
              </ActionList.Item>
              <ActionList.Divider />
            </>
          )}
          {Object.entries(buttonLabels).map(([value, label]) => {
            const selected = propertyValue === value
            return (
              <ActionList.Item
                key={value}
                selected={selected}
                onSelect={() => (selected ? onChange('') : onChange(value))}
              >
                {label}
              </ActionList.Item>
            )
          })}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  ) : (
    <CustomPropertySingleSelectPanel
      {...inputProps}
      propertyDefinition={{...propertyDefinition, allowedValues: ['true', 'false']}}
    />
  )
}

try{ CustomPropertyBooleanSelect.displayName ||= 'CustomPropertyBooleanSelect' } catch {}